<div class="rs-phone-control" [class.rs-phone-control_linear]="linear">
  <input
    [ng2TelInputOptions]="inputOptions"
    (countryChange)="onCountryChange($event)"
    [formControl]="middlewareControl"
    ng2TelInput
    type="text"
    [prefix]="getPrefix()"
    [mask]="getMask()"
    [showMaskTyped]="isTouched"
    placeholder="Phone Number"
    (click)="reactOnClick()"
    (focus)="reactOnClick()"
  />
</div>
